var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 4.66699H13.3334",
    stroke: "#6B7280",
    strokeWidth: 0.666667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.66699V3.86699C6 3.20033 6.53333 2.66699 7.2 2.66699H8.8C9.46667 2.66699 10 3.20033 10 3.86699V4.66699",
    stroke: "#6B7280",
    strokeWidth: 0.666667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.66699L11.4667 12.7337C11.4 13.267 10.9333 13.667 10.4 13.667H5.6C5.06667 13.667 4.6 13.267 4.53333 12.7337L4 4.66699",
    stroke: "#6B7280",
    strokeWidth: 0.666667
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 7.33301V10.6663",
    stroke: "#6B7280",
    strokeWidth: 0.666667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 7.33301V10.6663",
    stroke: "#6B7280",
    strokeWidth: 0.666667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.e24533959aad5ef4164555f45486ef71.svg";
export { ForwardRef as ReactComponent };